"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolData = void 0;
class ToolData {
    constructor(data) {
        this.sponsored = false;
        this.sponsoredFromDate = null;
        this.sponsoredToDate = null;
        if (data) {
            this.sponsored = data.sponsored || false;
            this.sponsoredFromDate = data.sponsoredFromDate || null;
            this.sponsoredToDate = data.sponsoredToDate || null;
        }
    }
}
exports.ToolData = ToolData;
//# sourceMappingURL=ToolData.js.map